import { Button } from 'react-bootstrap';

const BuilderControls = ({
  section,
  config,
  readOnly,
  onAddRow,
  onAddGroup,
  onStartThen,
  onStartUntil,
  onDone,
  onCancel,
  isSubmitting,
  showDoneButton = false,
  showCancelButton = false,
  addActionButtonText = 'AND',
  doneButtonText = 'Save Global Action',
  doneButtonVariant = 'dark',
  doneButtonClassName = '',
  doneButtonStyle = {},
}) => {
  if (readOnly) {
    return null;
  }

  if (section === 'conditions') {
    return (
      <div className="d-flex flex-wrap align-items-center gap-3 pt-2">
        <span className="fw-semibold">Add Condition:</span>
        <Button variant="primary" onClick={onAddRow}>
          AND
        </Button>
        <Button variant="primary" onClick={onAddGroup}>
          OR
        </Button>
        <Button variant="primary" onClick={onStartThen} disabled={!onStartThen}>
          THEN
        </Button>
      </div>
    );
  }

  if (section === 'actions') {
    return (
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 pt-2">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <span className="fw-semibold">Add Action:</span>
          <Button variant="primary" onClick={onAddRow}>
            {addActionButtonText}
          </Button>
          {!showDoneButton && (
            <Button variant="primary" onClick={onStartUntil} disabled={!onStartUntil}>
              UNTIL
            </Button>
          )}
        </div>
        {showDoneButton && (
          <div className="d-flex align-items-center gap-2">
            {showCancelButton && (
              <Button
                variant="primary"
                className="fw-bold px-4 py-2 rounded-3"
                onClick={onCancel}
                disabled={!onCancel || isSubmitting}
              >
                Cancel
              </Button>
            )}
            <Button
              variant={doneButtonVariant}
              className={`fw-bold px-4 py-2 rounded-3 ${doneButtonClassName}`}
              style={doneButtonStyle}
              onClick={onDone}
              disabled={!onDone || isSubmitting}
            >
              {isSubmitting ? 'Saving...' : doneButtonText}
            </Button>
          </div>
        )}
      </div>
    );
  }

  if (section === 'until') {
    return (
      <div className="d-flex flex-wrap align-items-center gap-3 pt-2">
        <span className="fw-semibold">Add Condition:</span>
        <Button variant="primary" onClick={onAddRow}>
          AND
        </Button>
        <Button variant="primary" onClick={onAddGroup}>
          OR
        </Button>
        <Button variant="primary" onClick={onDone} disabled={!onDone || isSubmitting}>
          {isSubmitting ? 'Saving...' : 'Done'}
        </Button>
      </div>
    );
  }

  return (
    <div className="d-flex flex-wrap gap-2 pt-2">
      <Button variant="primary" onClick={onAddRow}>
        {config.addRowLabel}
      </Button>
      {config.addGroupLabel && (
        <Button variant="primary" onClick={onAddGroup}>
          {config.addGroupLabel}
        </Button>
      )}
    </div>
  );
};

export default BuilderControls;
